export interface EstadoMeta {
  value: string;
  label: string;
  badge: string;
  dot: string;
}

export const estadosSolicitud: EstadoMeta[] = [
  {
    value: "nueva",
    label: "Nueva",
    badge: "bg-primary-100 text-primary-800 border-primary-200",
    dot: "bg-primary-500",
  },
  {
    value: "en_revision",
    label: "En revisión",
    badge: "bg-secondary-100 text-secondary-900 border-secondary-200",
    dot: "bg-secondary-500",
  },
  {
    value: "contactado",
    label: "Contactado",
    badge: "bg-accent-100 text-accent-900 border-accent-200",
    dot: "bg-accent-500",
  },
  {
    value: "cotizacion",
    label: "Cotización enviada",
    badge: "bg-accent-100 text-accent-900 border-accent-200",
    dot: "bg-accent-600",
  },
  {
    value: "confirmada",
    label: "Confirmada",
    badge: "bg-primary-100 text-primary-800 border-primary-200",
    dot: "bg-primary-600",
  },
  {
    value: "en_proceso",
    label: "En proceso",
    badge: "bg-accent-100 text-accent-900 border-accent-300",
    dot: "bg-accent-500",
  },
  {
    value: "completada",
    label: "Completada",
    badge: "bg-secondary-100 text-secondary-900 border-secondary-300",
    dot: "bg-secondary-600",
  },
  {
    value: "cancelada",
    label: "Cancelada",
    badge: "bg-background-200 text-foreground-600 border-background-300",
    dot: "bg-foreground-400",
  },
];

const estadoFallback: EstadoMeta = {
  value: "nueva",
  label: "Nueva",
  badge: "bg-background-200 text-foreground-600 border-background-300",
  dot: "bg-foreground-400",
};

export function getEstadoMeta(value?: string | null): EstadoMeta {
  if (!value) return estadoFallback;
  return estadosSolicitud.find((estado) => estado.value === value) ?? { ...estadoFallback, value, label: value };
}

export const ESTADOS_ACTIVOS = ["nueva", "en_revision", "contactado", "cotizacion", "confirmada", "en_proceso"];
export const ESTADOS_CERRADOS = ["completada", "cancelada"];